package lacaravana.domain

import lacaravana.app.Database

data class MenuItem(
    val id: String, val nombre: String, val categoria: String,
    val precioCents: Int, val disponible: Boolean, val orden: Int
)

object Menu {
    suspend fun all(db: Database): List<MenuItem> =
        db.query("SELECT id, nombre, categoria, precio_cents, disponible, orden FROM menu_items ORDER BY categoria, orden")
            .map { row ->
                MenuItem(
                    id = row[0] as String, nombre = row[1] as String,
                    categoria = row[2] as String, precioCents = (row[3] as Number).toInt(),
                    disponible = (row[4] as Number).toInt() == 1, orden = (row[5] as Number).toInt()
                )
            }

    suspend fun available(db: Database): List<MenuItem> =
        all(db).filter { it.disponible }

    suspend fun add(db: Database, nombre: String, categoria: String, precioCents: Int) {
        val id = js("crypto.randomUUID()") as String
        db.execute(
            "INSERT INTO menu_items (id, nombre, categoria, precio_cents) VALUES (?, ?, ?, ?)",
            arrayOf(id, nombre, categoria, precioCents)
        )
    }

    suspend fun toggleDisponible(db: Database, id: String) {
        db.execute(
            "UPDATE menu_items SET disponible = 1 - disponible, updated_at = datetime('now') WHERE id = ?",
            arrayOf(id)
        )
    }

    suspend fun delete(db: Database, id: String) {
        db.execute("DELETE FROM menu_items WHERE id = ?", arrayOf(id))
    }

    fun formatPrice(cents: Int): String {
        val euros = cents / 100
        val centsPart = cents % 100
        return "$euros,${centsPart.toString().padStart(2, '0')} €"
    }
}
